var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "HqDrawer",
    {
      ref: "drawer",
      attrs: {
        title: "收款明细",
        showHeader: false,
        visible: _vm.showVisisble,
        size: "90%"
      },
      on: {
        "update:visible": function($event) {
          _vm.showVisisble = $event
        }
      }
    },
    [
      _c("div", { staticClass: "header" }, [
        _c(
          "h3",
          {
            class: _vm.navIndex == 0 ? "selected" : "",
            on: {
              click: function($event) {
                return _vm.toNav(0)
              }
            }
          },
          [_vm._v("收款明细")]
        ),
        _c(
          "h3",
          {
            class: _vm.navIndex == 1 ? "selected" : "",
            on: {
              click: function($event) {
                return _vm.toNav(1)
              }
            }
          },
          [_vm._v("优惠明细")]
        )
      ]),
      _c(
        "div",
        { staticClass: "ty-drawer-content" },
        [
          _vm.navIndex == 0
            ? [
                _c("div", { staticClass: "ty-try-header" }, [
                  _c("p", [
                    _c("span", [
                      _c("i", { staticClass: "iconfont iconxieyiguanli" }),
                      _vm._v(_vm._s(_vm.orderGoodsVo.goodsName))
                    ]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.orderGoodsVo.commodityName))
                    ]),
                    _c("span", { staticClass: "fr" }, [
                      _vm._v("应收金额:"),
                      _c(
                        "i",
                        {
                          staticClass: "red1",
                          staticStyle: { "margin-right": "24px", color: "red" }
                        },
                        [_vm._v("￥ " + _vm._s(_vm.orderGoodsVo.payPrice))]
                      ),
                      _vm._v("已收金额:"),
                      _c(
                        "i",
                        { staticClass: "red1", staticStyle: { color: "red" } },
                        [
                          _vm._v(
                            "￥ " + _vm._s(_vm.orderGoodsVo.amountReceivedAll)
                          )
                        ]
                      )
                    ])
                  ])
                ]),
                _vm._l(_vm.tableData, function(data, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticStyle: {
                        "margin-top": "10px",
                        "margin-bottom": "20px",
                        padding: "0 30px 0 0"
                      }
                    },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%", margin: "10px 0" },
                          attrs: {
                            border: "",
                            stripe: "",
                            size: "mini",
                            "element-loading-text": "拼命加载中",
                            "header-cell-style": { background: "#e5f2ff" },
                            "max-height": "700px",
                            data: data.paySummaryList
                          }
                        },
                        [
                          data.paySummaryList[0].countNumber != undefined
                            ? _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  width: "140",
                                  prop: "countNumber",
                                  label: "支付笔数"
                                }
                              })
                            : _vm._e(),
                          data.paySummaryList[0].payTime != undefined
                            ? _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  formatter: _vm.formatDate,
                                  width: "140",
                                  prop: "payTime",
                                  label: "支付时间"
                                }
                              })
                            : _vm._e(),
                          data.paySummaryList[0].loanStage != undefined
                            ? _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  formatter: _vm.formatFormAllData,
                                  width: "140",
                                  prop: "loanStage",
                                  label: "支付阶段"
                                }
                              })
                            : _vm._e(),
                          data.paySummaryList[0].downPayment != undefined
                            ? _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  width: "140",
                                  formatter: _vm.numberFormatter,
                                  prop: "downPayment",
                                  label: "首付款"
                                }
                              })
                            : _vm._e(),
                          data.paySummaryList[0].loanAmount != undefined
                            ? _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  width: "140",
                                  formatter: _vm.numberFormatter,
                                  prop: "loanAmount",
                                  label: "贷款金额"
                                }
                              })
                            : _vm._e(),
                          data.paySummaryList[0].type == 2
                            ? _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  formatter: _vm.numberFormatter,
                                  width: "140",
                                  prop: "paymentAmount",
                                  label: "支付金额"
                                }
                              })
                            : _vm._e(),
                          data.paySummaryList[0].installmentStatus != undefined
                            ? _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  formatter: _vm.formatFormAllData,
                                  width: "140",
                                  prop: "installmentStatus",
                                  label: "贷款状态"
                                }
                              })
                            : _vm._e(),
                          data.paySummaryList[0].installmentNumber != undefined
                            ? _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  "min-width": "100",
                                  prop: "installmentNumber",
                                  label: "贷款期数"
                                }
                              })
                            : _vm._e(),
                          data.paySummaryList[0].discountRate != undefined
                            ? _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  "min-width": "100",
                                  prop: "discountRate",
                                  label: "贴息率"
                                }
                              })
                            : _vm._e(),
                          data.paySummaryList[0].discountAmount != undefined
                            ? _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  "min-width": "100",
                                  prop: "discountAmount",
                                  label: "贴息"
                                }
                              })
                            : _vm._e(),
                          data.paySummaryList[0].accountAmount != undefined
                            ? _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  "min-width": "100",
                                  prop: "accountAmount",
                                  label: "到账金额"
                                }
                              })
                            : _vm._e(),
                          data.paySummaryList[0].test7 != undefined
                            ? _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  "min-width": "100",
                                  prop: "test7",
                                  label: "降贷"
                                }
                              })
                            : _vm._e(),
                          data.paySummaryList[0].loanReceiptNo != undefined
                            ? _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  "min-width": "100",
                                  prop: "loanReceiptNo",
                                  label: "借据号"
                                }
                              })
                            : _vm._e(),
                          data.paySummaryList[0].changeClassDiscount !== "0"
                            ? _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  "min-width": "100",
                                  formatter: _vm.numberFormatter,
                                  prop: "changeClassDiscount",
                                  label: "转班抵扣"
                                }
                              })
                            : _vm._e(),
                          data.paySummaryList[0].deduction !== "0"
                            ? _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  "min-width": "100",
                                  formatter: _vm.numberFormatter,
                                  prop: "deduction",
                                  label: "余额抵扣"
                                }
                              })
                            : _vm._e(),
                          data.paySummaryList[0].payType != undefined
                            ? _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  formatter: _vm.formatFormAllData,
                                  width: "140",
                                  prop: "payType",
                                  label: "支付方式"
                                }
                              })
                            : _vm._e(),
                          data.paySummaryList[0].thirdName != undefined
                            ? _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  width: "140",
                                  prop: "thirdName",
                                  label: "第三方"
                                }
                              })
                            : _vm._e(),
                          data.paySummaryList[0].thirdOrderNo != undefined
                            ? _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  width: "140",
                                  prop: "thirdOrderNo",
                                  label: "第三方订单号"
                                }
                              })
                            : _vm._e(),
                          data.paySummaryList[0].tradeNo != undefined
                            ? _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  width: "270",
                                  prop: "tradeNo",
                                  label: "商户订单号"
                                }
                              })
                            : _vm._e(),
                          data.paySummaryList[0].tradeSerialNumber != undefined
                            ? _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  width: "250",
                                  prop: "tradeSerialNumber",
                                  label: "交易号"
                                }
                              })
                            : _vm._e(),
                          data.paySummaryList[0].deductionUserMobile !=
                          undefined
                            ? _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  width: "140",
                                  prop: "deductionUserMobile",
                                  label: "学员账号"
                                }
                              })
                            : _vm._e(),
                          data.paySummaryList[0].deductionUserName != undefined
                            ? _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  width: "140",
                                  prop: "deductionUserName",
                                  label: "学员姓名"
                                }
                              })
                            : _vm._e(),
                          data.paySummaryList[0].amountToBeReceived != undefined
                            ? _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  "min-width": "100",
                                  formatter: _vm.numberFormatter,
                                  prop: "amountToBeReceived",
                                  label: "待收金额"
                                }
                              })
                            : _vm._e(),
                          data.paySummaryList[0].downPaymentAllPay != undefined
                            ? _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  formatter: _vm.formatFormAllData,
                                  "min-width": "100",
                                  prop: "downPaymentAllPay",
                                  label: "首付收齐款"
                                }
                              })
                            : _vm._e(),
                          data.paySummaryList[0].allPay != undefined
                            ? _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  formatter: _vm.formatFormAllData,
                                  "min-width": "100",
                                  prop: "allPay",
                                  label: "收齐款",
                                  "label-class-name": "ty-ml8"
                                }
                              })
                            : _vm._e(),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              "min-width": "100",
                              prop: "allPay",
                              label: "凭证",
                              fixed: "right"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      scope.row.photoUrl
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: { type: "text" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.seeClick(scope.row)
                                                }
                                              }
                                            },
                                            [_vm._v("查看")]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              "min-width": "100",
                              prop: "allPay",
                              label: "凭证视频",
                              fixed: "right"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      scope.row.videoUrl
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: { type: "text" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.seeVideoClick(
                                                    scope.row
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("查看")]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-dialog",
                        {
                          attrs: {
                            "append-to-body": "",
                            title: "凭证视频",
                            visible: _vm.videoDialogVisible,
                            width: "800px",
                            "before-close": _vm.closeVideoDialog,
                            "close-on-click-modal": false,
                            "append-to-body": true
                          },
                          on: {
                            "update:visible": function($event) {
                              _vm.videoDialogVisible = $event
                            },
                            closed: _vm.afterDialogClosed
                          }
                        },
                        [
                          _c("div", { staticClass: "video-container" }, [
                            _vm.currentVideoUrl
                              ? _c(
                                  "video",
                                  {
                                    ref: "videoPlayer",
                                    refInFor: true,
                                    staticStyle: { "max-height": "70vh" },
                                    attrs: {
                                      src: _vm.currentVideoUrl,
                                      controls: "",
                                      width: "100%",
                                      height: "auto"
                                    }
                                  },
                                  [_vm._v(" 您的浏览器不支持视频播放。 ")]
                                )
                              : _c("div", { staticClass: "no-video-tip" }, [
                                  _vm._v("视频地址无效")
                                ])
                          ])
                        ]
                      ),
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%", margin: "30px 0" },
                          attrs: {
                            "max-height": "500",
                            data: data.orderInOutProjectDtoList,
                            border: "",
                            stripe: "",
                            size: "mini",
                            "element-loading-text": "拼命加载中",
                            "header-cell-style": { background: "#F5F7FB" }
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              fixed: "",
                              prop: "inoutProjectCode",
                              label: "收支项目编码",
                              width: "140"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              fixed: "",
                              prop: "inoutProjectName",
                              label: "收支项目名称",
                              width: "140"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              prop: "inoutProportionStr",
                              label: "收支占比",
                              width: "140"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              prop: "chargeOrder",
                              label: "收费顺序",
                              width: "140"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              formatter: _vm.numberFormatter,
                              prop: "standardPrice",
                              label: "标准价格",
                              width: "140"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              formatter: _vm.numberFormatter,
                              prop: "goodsDiscount",
                              label: "优惠额",
                              width: "140"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return _c("div", {}, [
                                      _vm._v(
                                        " " +
                                          _vm._s(scope.row.goodsDiscount) +
                                          " "
                                      )
                                    ])
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              formatter: _vm.numberFormatter,
                              prop: "receivable",
                              label: "应收金额",
                              width: "140"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              formatter: _vm.numberFormatter,
                              prop: "settleAccounts",
                              label: "本次实收金额",
                              width: "140"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              formatter: _vm.numberFormatter,
                              prop: "settledAmount",
                              label: "累计已收金额",
                              width: "140"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              prop: "discountPercentageStr",
                              label: "优惠百分比",
                              width: "140"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              prop: "performanceRatioStr",
                              label: "绩效比例",
                              width: "140"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              prop: "completionRatioStr",
                              label: "完成率比例",
                              width: "140"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              prop: "inoutProjectType",
                              label: "收支项目类型",
                              "min-width": "120"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              prop: "calculatePerformance",
                              label: "是否计算绩效",
                              "min-width": "120"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              prop: "incomeMethod",
                              label: "计算收入方式",
                              "min-width": "150"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              prop: "monthlyApportionmentOrNot",
                              label: "是否按月分摊",
                              "min-width": "120"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              prop: "incomeApportionmentCycle",
                              label: "收入分摊周期(月)",
                              width: "140"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              prop: "startApportionmentCycle",
                              label: "开始分摊周期(月)",
                              width: "140"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              prop: "apportionmentRatioStr",
                              label: "分摊比例",
                              width: "140"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              prop: "countyApportionmentRatioStr",
                              label: "自营三分成比例",
                              width: "140"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              prop: "selfSupportRatioStr",
                              label: "自营二分成比例",
                              width: "140",
                              "label-class-name": "ty-ml8"
                            }
                          })
                        ],
                        1
                      ),
                      _c("div", { staticStyle: { "margin-top": "10px" } }),
                      _c("el-image", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: false,
                            expression: "false"
                          }
                        ],
                        ref: "previewImg",
                        refInFor: true,
                        attrs: { src: _vm.url, "preview-src-list": [_vm.url] }
                      })
                    ],
                    1
                  )
                })
              ]
            : _vm._e(),
          _vm.navIndex == 1
            ? [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            width: "400px",
                            label: "优惠总金额",
                            "hide-details": "auto",
                            outlined: "",
                            readonly: "",
                            dense: true,
                            height: 32
                          },
                          model: {
                            value: _vm.discountAmount,
                            callback: function($$v) {
                              _vm.discountAmount = $$v
                            },
                            expression: "discountAmount"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                !_vm.discountList || _vm.discountList.length == 0
                  ? [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%", margin: "30px 0" },
                          attrs: {
                            "max-height": "500",
                            data: [{}],
                            border: "",
                            stripe: "",
                            size: "mini",
                            "element-loading-text": "拼命加载中",
                            "header-cell-style": { background: "#e5f2ff" }
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              label: "优惠笔数",
                              "min-width": "150"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              prop: "discount",
                              label: "优惠金额",
                              "min-width": "220"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              prop: "type",
                              label: "使用时间",
                              "min-width": "140"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              prop: "type",
                              label: "优惠类型",
                              "min-width": "140"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              prop: "xxxxx",
                              label: "状态",
                              "min-width": "140"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": true,
                              prop: "orderId",
                              label: "售后单号",
                              "min-width": "240"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  : _vm._l(_vm.discountList, function(item, index) {
                      return [
                        _c(
                          "el-table",
                          {
                            key: index,
                            staticStyle: { width: "100%", margin: "30px 0" },
                            attrs: {
                              "max-height": "500",
                              data: [item],
                              border: "",
                              stripe: "",
                              size: "mini",
                              "element-loading-text": "拼命加载中",
                              "header-cell-style": { background: "#e5f2ff" }
                            }
                          },
                          [
                            _c(
                              "el-table-column",
                              {
                                attrs: {
                                  "show-overflow-tooltip": true,
                                  label: "优惠笔数",
                                  "min-width": "150"
                                }
                              },
                              [_vm._v("第 " + _vm._s(index + 1) + " 笔")]
                            ),
                            _c("el-table-column", {
                              attrs: {
                                "show-overflow-tooltip": true,
                                prop: "discount",
                                label: "优惠金额",
                                "min-width": "120"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                "show-overflow-tooltip": true,
                                prop: "type",
                                label: "使用时间",
                                "min-width": "240"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("formatDate")(
                                                scope.row.useTime,
                                                "YYYY-MM-DD HH:mm:ss"
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            }),
                            _c("el-table-column", {
                              attrs: {
                                "show-overflow-tooltip": true,
                                prop: "type",
                                label: "活动ID",
                                "min-width": "140"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(scope.row.activityId) +
                                            " "
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            }),
                            _c("el-table-column", {
                              attrs: {
                                "show-overflow-tooltip": true,
                                prop: "type",
                                label: "优惠类型",
                                "min-width": "140"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(scope.row.activityName) +
                                            " "
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            }),
                            _c("el-table-column", {
                              attrs: {
                                "show-overflow-tooltip": true,
                                prop: "xxxxx",
                                label: "状态",
                                "min-width": "140"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        scope.row.status == 0
                                          ? _c(
                                              "div",
                                              { staticStyle: { color: "red" } },
                                              [_vm._v("未使用")]
                                            )
                                          : _vm._e(),
                                        scope.row.status == 1
                                          ? _c(
                                              "div",
                                              {
                                                staticStyle: { color: "green" }
                                              },
                                              [_vm._v("已使用")]
                                            )
                                          : _vm._e(),
                                        scope.row.status == 2
                                          ? _c("div", [_vm._v("已过期")])
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            }),
                            item.type === 1
                              ? _c("el-table-column", {
                                  attrs: {
                                    "show-overflow-tooltip": true,
                                    prop: "afterSaleId",
                                    label: "售后单号",
                                    "min-width": "240"
                                  }
                                })
                              : _vm._e(),
                            item.type === 0
                              ? _c("el-table-column", {
                                  attrs: {
                                    "show-overflow-tooltip": true,
                                    prop: "activityId",
                                    label: "活动ID",
                                    "min-width": "140"
                                  }
                                })
                              : _vm._e(),
                            item.type === 0
                              ? _c("el-table-column", {
                                  attrs: {
                                    "show-overflow-tooltip": true,
                                    prop: "activityName",
                                    label: "活动名称",
                                    "min-width": "240"
                                  }
                                })
                              : _vm._e(),
                            item.type === 0
                              ? _c("el-table-column", {
                                  attrs: {
                                    "show-overflow-tooltip": true,
                                    prop: "activityEndTime",
                                    label: "活动时间",
                                    "min-width": "240"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("div", [
                                              _c("div", [
                                                _vm._v(
                                                  "开始: " +
                                                    _vm._s(
                                                      _vm._f("formatDate2")(
                                                        scope.row
                                                          .activityStartTime,
                                                        "YYYY-MM-DD HH:mm:ss"
                                                      )
                                                    )
                                                )
                                              ]),
                                              _c("div", [
                                                _vm._v(
                                                  "结束: " +
                                                    _vm._s(
                                                      _vm._f("formatDate2")(
                                                        scope.row
                                                          .activityEndTime,
                                                        "YYYY-MM-DD HH:mm:ss"
                                                      )
                                                    )
                                                )
                                              ])
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    })
              ]
            : _vm._e()
        ],
        2
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.cancel()
                }
              }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }